import {useState} from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import {MInput, RadioButtonGroup} from 'components/forms/inputs'
import {notificationTypes} from 'components/filters/constants'
import type {Subscription as SubType, SubscriptionType} from 'services/types'
import type {AlertStageProps} from './types'
import {EMAIL, PHONE_CALL, TEXT_MESSAGE, WEBHOOK} from 'services/constants'
import {Typography} from '@mui/material'
import AddItem from 'components/search/AddItem'

type SubscriptionProps = {
  subscription: SubType
  onChange: (n: SubType) => void
}
const Subscription = ({subscription, onChange}: SubscriptionProps) => {
  const [selected, setSelected] = useState(subscription.method as string)

  const onSelected = (selected?: string) => {
    if (selected) {
      setSelected(selected)
      onChange({...subscription, method: selected as SubscriptionType})
    }
  }
  const onPayloadChange = (v: string) => onChange({...subscription, destination: v})

  const labels = {
    [EMAIL]: 'Email addres',
    [WEBHOOK]: 'Webhook URL',
    [TEXT_MESSAGE]: 'Phone number',
    [PHONE_CALL]: 'Phone number',
  }

  return (
    <Card sx={{width: '100%', height: '100%', borderRadius: 3, p: 2}}>
      <CardContent>
        <Box sx={{pl: 3}}>
          <RadioButtonGroup
            perRow={4}
            selected={selected}
            onSelect={onSelected}
            items={Object.entries(notificationTypes).map(([id, label]) => ({id, label}))}
          />
        </Box>
        <Box sx={{pr: 6}}>
          <MInput
            label={labels[selected as keyof typeof labels]}
            value={subscription.destination || ''}
            setter={onPayloadChange}
            fullWidth
          />
        </Box>
      </CardContent>
    </Card>
  )
}

const NotificationMethods = ({alert, onChange, enableNext, index}: AlertStageProps) => {
  const handleChange = (i: number) => (s: SubType) => {
    if (!alert.subscriptions) return

    alert.subscriptions[i] = s
    onChange('subscriptions', alert.subscriptions)
  }

  return (
    <Stack spacing={4}>
      <Typography variant="h5">
        We will send alerts to your email address, but you can also specify additional ways of
        getting notified
      </Typography>
      {alert.subscriptions?.map((sub, i) => (
        <Subscription key={i} subscription={sub} onChange={handleChange(i)} />
      ))}
      {(alert?.subscriptions?.length || 0) < 20 ? (
        <AddItem
          label="Add notification method"
          action={() =>
            onChange('subscriptions', [...(alert.subscriptions || []), {method: EMAIL} as SubType])
          }
        />
      ) : undefined}
    </Stack>
  )
}

export default NotificationMethods
